module.exports = __webpack_public_path__ + "static/media/damian-avila.723cba98.jpg";